import React, { Component, useEffect, useState } from "react";
import { useAppLibs } from "../../ContextProvider/AppLib_Provider";

import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import ProjectCard from "./ProjectCard";
import ProjectSubmissionView from "./ProjectSubmissionView";
import Drawer from "../Drawer";
import LoadingComp from "../LoadingComp";

const ProjectDashboard = ({ props }) => {
  const { user } = props;
  const [isVisible, setVisible] = useState(false);
  const [activeSubject, setActiveSubject] = useState(3);
  const { Projects } = useAppLibs();
  const [loading, setLoading] = useState(false);
  const [allProjects, setAllProjects] = useState([]);
  const [projects, setProjects] = useState([]);
  const SUBJECT = Projects.SUBJECT;
  const levelInitialState = { 1: [], 2: [], 3: [] };
  const [levelWiseProject, setLevelWiseProject] = useState(levelInitialState);
  var initialDrawerSt = { isOpen: false, Component: null, componentProps: {} };
  const [drawerState, setDrawerState] = useState(initialDrawerSt);

  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);
      try {
        const result = await Projects.getProjects();
        if (result.success) {
          setAllProjects((prev) => result.data);
          setVisible(true);
        } else {
          // showToast(result.error, "error", true, 3000);
        }
      } catch (error) {
        //   showToast(error.message, "error", true, 3000);
      } finally {
        setActiveSubject((prev) => 1);
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  const openDrawer = (Component, componentProps = {}) => {
    setDrawerState({ isOpen: true, Component: Component, componentProps });
  };

  const onView = (item, index) => {
    openDrawer(ProjectSubmissionView, { item, index, user });
  };
  const closeDrawer = () => {
    setDrawerState((prev) => initialDrawerSt);
  };

  // Convert activeSubject to a number for comparison:
  const HanndleSubjectChanged = (activeSubject) => {
    const obj = {};
    allProjects
      .filter((pro) => Number(pro.subject) === Number(activeSubject))
      .forEach((p) => {
        const level = p.level;
        if (!obj[level]) obj[level] = [];
        obj[level].push(p);
      });
    setLevelWiseProject(obj);
  };

  useEffect(() => {
    HanndleSubjectChanged(activeSubject);
  }, [activeSubject]);

  return (
    <div
      className="flex-1 overflow-y-auto overflow-x-hidden space-y-4 h-[calc(100vh-65px)]"
      key="ProjectDashboard"
    >
      <div className="animate-fade-in flex mb-6 p-2 max-w-fit rounded-lg bg-base-200 gap-3 overflow-x-auto whitespace-nowrap transition-all duration-500 ease-in-out transform scale-100">
        {Object.entries(SUBJECT).map(([tab, display]) => (
          <button
            key={tab}
            className={`px-4 py-2 rounded-lg transition duration-300 ease-in-out transform ${
              activeSubject == tab
                ? "bg-pink-800 text-white shadow-lg scale-105"
                : "text-gray-700 bg-[#FAF5FF] hover:bg-violet-100 hover:scale-105"
            }`}
            onClick={() => setActiveSubject(tab)}
          >
            {display}
          </button>
        ))}
      </div>

      {allProjects.length > 0 && (
        <div
          className={` rounded-lg shadow-sm w-full space-y-2 transition-transform duration-700 ease-in-out transform ${
            isVisible
              ? "translate-x-0 opacity-100"
              : "translate-x-[-100%] opacity-0"
          }`}
        >
          <div className="collapse bg-gray-50" key="Beginner">
            <input type="checkbox" />
            <div className="collapse-title text-xl font-medium flex space-x-2">
              <h3>Beginner</h3>{" "}
              <span className="bg-pink-100 text-pink-700 text-sm px-3 py-1 rounded-full font-medium">
                {levelWiseProject[1]?.length || 0} Projects
              </span>
            </div>

            <div className="collapse-content" key="BeginnerProjects">
              {levelWiseProject[1]?.length ? (
                levelWiseProject[1].map((item, index) => (
                  <ProjectCard props={{ index, item, onView }} />
                ))
              ) : (
                <p>No Project Yet</p>
              )}
            </div>
          </div>

          <div className="collapse bg-gray-50" key="Intermediate">
            <input type="checkbox" />
            <div className="collapse-title text-xl font-medium flex space-x-2">
              <h2>Intermediate</h2>
              <span className="bg-pink-100 text-pink-700 text-sm px-3 py-1 rounded-full font-medium">
                {levelWiseProject[2]?.length || 0} Projects
              </span>
            </div>
            <div className="collapse-content">
              {levelWiseProject[2]?.length ? (
                levelWiseProject[2].map((item, index) => (
                  <ProjectCard props={{ index, item, onView }} />
                ))
              ) : (
                <p>No Project Yet</p>
              )}
            </div>
          </div>

          <div className="collapse bg-gray-50" key="Advance">
            <input type="checkbox" />
            <div className="collapse-title text-xl font-medium flex space-x-2">
              <h2>Advance</h2>
              <span className="bg-pink-100 text-pink-700 text-sm px-3 py-1 rounded-full font-medium">
                {levelWiseProject[3]?.length || 0} Projects
              </span>
            </div>
            <div className="collapse-content">
              {levelWiseProject[3]?.length ? (
                levelWiseProject[3].map((item, index) => (
                  <ProjectCard props={{ index, item, onView }} />
                ))
              ) : (
                <p>No Project Yet</p>
              )}
            </div>
          </div>
        </div>
      )}
      <Drawer props={{ ...drawerState, closeFn: closeDrawer }} />

      {loading && <LoadingComp message={"Projects loading "} />}
      {!loading && allProjects.length === 0 && (
        <LoadingComp message={"No project found ! "} loaded={true} />
      )}
    </div>
  );
};

export default ProjectDashboard;
